import React, { FunctionComponent } from 'react';

import moment from 'moment';
import styled from 'styled-components';

import { formatMoney } from '@webapp/utils/formatMoney';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import { Translate } from 'react-localize-redux';
import DownloadIcon from '@components/basics/icons/download';

interface ArtistInvoiceItemProps {
  className?: string;
  number: string;
  type: string;
  price: number;
  date: Date;
  isPaid: boolean;
  onClick: () => void;
}

const ArtistInvoiceItem: FunctionComponent<ArtistInvoiceItemProps> = ({
  className,
  number,
  type,
  price,
  date,
  isPaid,
  onClick,
}) => {
  return (
    <Wrapper>
      <div className={className || ''}>
        <Flex
          className="mb-5"
          justifyContent="space-between"
          alignItems="center"
          gap={10}
        >
          <Typography type="small">
            <Translate
              id="ARTIST_PROFILE.INVOICES.TEXT"
              data={{ number: number }}
            />
          </Typography>
          <Typography type="small" align="right">
            {formatMoney(price)}
          </Typography>
        </Flex>
        <Flex
          className="secondary"
          justifyContent="space-between"
          alignItems="center"
          gap={10}
        >
          <Typography type="small">{type}</Typography>
          <Typography type="small" align="right">
            {moment(date).format("MMM DD 'YY")}
          </Typography>
        </Flex>
      </div>
      {isPaid ? <StyledDownloadIcon onClick={onClick} /> : null}
    </Wrapper>
  );
};

export default styled(ArtistInvoiceItem)`
  .secondary {
    span {
      color: ${({ theme }) => theme.colors.tertiary};
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

const StyledDownloadIcon = styled(DownloadIcon)`
  height: 20px;
`;
